export default "__VITE_ASSET__fd5c1827__"